import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'onboarding-onboarding-validation-modal',
  templateUrl: './onboarding-validation-modal.component.html',
  styleUrls: ['./onboarding-validation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OnboardingValidationModalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private fb = inject(FormBuilder);

  public form: FormGroup;

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm() {
    this.form = this.fb.group({
      checkAgree: [false],
    });
  }

  close(skip: boolean) {
    this.activeModal.close(skip);
  }
}
